// 🚪 Salle d'un cours fermée par une action faite hors de la salle (« Élève absent » depuis le
// bandeau) : la salle Zoom de ce cours se quitte toute seule. Deux signaux, au premier arrivé :
// l'événement du serveur (« class-no-show », envoyé au prof et à l'élève) et un événement de la
// page, envoyé par le bandeau dès que l'API a répondu (même si le socket est coupé).
export const ROOM_CLOSED_EVENT = "acadeclic:class-closed";

// Le bandeau : cours clos (élève absent)
export const announceClassClosed = (classId) => {
  if (!classId) return;
  window.dispatchEvent(new CustomEvent(ROOM_CLOSED_EVENT, { detail: { classId: String(classId) } }));
};

// Événement (serveur ou page) qui concerne la salle de ce cours ?
export const closesThisRoom = (data, classId) => !!classId && !!data?.classId && String(data.classId) === String(classId);

// La salle : appelle onClosed une seule fois quand son cours est clos. Renvoie de quoi se
// désabonner.
export const watchRoomClosed = ({ socket, classIdOf, onClosed }) => {
  let done = false;
  const handle = (data) => {
    if (done || !closesThisRoom(data, classIdOf())) return;
    done = true;
    onClosed(data);
  };
  const fromPage = (event) => handle(event.detail);
  socket?.on("class-no-show", handle);
  window.addEventListener(ROOM_CLOSED_EVENT, fromPage);
  return () => {
    socket?.off("class-no-show", handle);
    window.removeEventListener(ROOM_CLOSED_EVENT, fromPage);
  };
};
